export default "__VITE_ASSET__19baa615__"